import AdminLayout from "../../../components/AdminLayout";
import { Cabecalho, Pagina } from "../../../components/AdminLayout/Pagina";
import Relatorio from "../../../../models/Relatorio";
import ResumoKpis from "../../Relatorios/ResumoKpis";
import { useRelatorio } from "../../Relatorios/useRelatorio";
import { BlocoAtalhos, BlocoCrescimento, BlocoPendentes, BlocoPlataforma, BlocoRecentes } from "./blocos";

// Visão geral da plataforma para o administrador. Ordem pensada por prioridade:
// o que pede ação (pedidos), os números de pessoas e plantios, o ritmo de
// crescimento, o tamanho da comunidade e, por fim, o que acabou de acontecer.
//
// Cada bloco carrega e falha sozinho: um endpoint fora do ar não derruba a página.
// O resumo é consultado UMA vez e repartido entre os blocos que o usam.
export default function Painel() {
  const resumo = useRelatorio(Relatorio.resumo);

  return (
    <AdminLayout>
      <Pagina>
        <Cabecalho titulo="Painel" descricao="Visão geral da plataforma Plantando para o Planeta." />
        <BlocoPendentes resumo={resumo} />
        <ResumoKpis externo={resumo} semPendencias />
        <BlocoCrescimento />
        <BlocoPlataforma resumo={resumo} />
        <BlocoRecentes />
        <BlocoAtalhos />
      </Pagina>
    </AdminLayout>
  );
}
